<template>
  <template v-if="variant === 'text'">
    <a v-if="textType === 'inverted'" class="red">
      <slot></slot>
      <img class="ico-base" :src="icon" :alt="iconAlt" />
    </a>

    <div
      v-else-if="textType === 'outside' || textType === 'red'"
      class="btn-outside"
      :class="{ red: textType === 'red' }"
    >
      <img class="ico-base" :src="icon" :alt="iconAlt" />
      <slot></slot>
    </div>

    <a v-else class="btn-s">
      <img class="ico-base" :src="icon" :alt="iconAlt" />
      <slot></slot>
    </a>
  </template>

  <button
    v-else-if="variant === 'modal'"
    class="btn btn-main"
    data-bs-toggle="modal"
    :data-bs-target="`#${modalId}`"
  >
    <slot></slot>
  </button>

  <button
    v-else-if="variant === 'modal-dismiss'"
    type="button"
    class="btn btn-cancel"
    data-bs-dismiss="modal"
  >
    <slot></slot>
  </button>

  <button v-else :class="`btn ${className}`">
    <div v-if="add" class="ico-base ico-add">
      <div class="ico-plus"></div>
    </div>
    <img v-if="icon" class="ico-base" :src="icon" :alt="iconAlt" />
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Button",
  props: {
    // variant: [ main, sub, cancel, delete, file, text, modal, modal-dismiss ]
    variant: {
      type: String,
      default: "main",
    },
    small: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    add: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: "",
    },
    iconAlt: {
      type: String,
      default: "",
    },
    // textType: [ default, outside, red, inverted ]
    textType: {
      type: String,
      default: "",
    },
    modalId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      className: "btn-main",
      variants: {
        main: "btn-main",
        sub: "btn-sub",
        cancel: "btn-cancel",
        delete: "btn-delete",
        file: "btn-file",
        circle: "btn-circle btn-sub btn-s",
      },
    };
  },
  created() {
    this.className = this.variants.hasOwnProperty(this.variant)
      ? this.variants[this.variant]
      : "";

    if (this.active) {
      this.className += " active";
    }

    if (this.variant === "sub" && this.small) {
      this.className += " btn-s";
    }
  },
};
</script>
